__turbopack_context__.v({
  "loader": "kgB5Yq_loader",
  "loadingLabel": "kgB5Yq_loadingLabel",
});
